import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CertificatesCardComponent } from "../../components/cards/certificates-card/certificates-card.component";
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { ContentService } from 'src/app/services/content.service';
import { FechaEsPipe } from "../../shared/interfaces/fecha-es.pipe";
import { CoursesService } from 'src/app/services/courses.service';
import { LessonsService } from 'src/app/services/lessons.service';
import { DataLesson } from 'src/app/shared/interfaces/lesson.interface';
import { nextWeek, thisWeek } from 'src/app/shared/functions';
import { Subject, Subscription, catchError, combineLatest, forkJoin, map, of, switchMap, takeUntil } from 'rxjs';
import { LoaderComponent } from "../../components/loader/loader.component";
import { DataCourse } from 'src/app/shared/interfaces/course.interface';
import { CertificatesService } from 'src/app/services/certificates.service';
import { InsigniasService } from 'src/app/services/insignias.service';
import { TooltipDirective } from 'src/app/shared/directives/app-tooltip.directive';

@Component({
    selector: 'app-learning-zone',
    standalone: true,
    templateUrl: './learning-zone.component.html',
    styleUrls: ['./learning-zone.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule, RouterModule, CertificatesCardComponent, FechaEsPipe, LoaderComponent, TooltipDirective]
})
export class LearningZoneComponent {
  option: string = 'Todos los pendientes';
  hasCourses:boolean = true;
  coursesWithInsignia: DataCourse[] = [];
  insignias: any;
  user:any;
  infoUser: any;
  activityPaths:any = [];
  activities: DataLesson[] = [];
  filteredActivities: DataLesson[] = [];
  filtAct:any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  pathLessons: Subscription;

  constructor( private localStorage:LocalstorageService, public content: ContentService, public courses:CoursesService, private lessonsService: LessonsService,
    private coursesService: CoursesService, private certificatesService: CertificatesService, public insigniasService: InsigniasService)
    {
      this.pathLessons = this.content.executeInLearningZone$.pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (resp: boolean) => {
            if(resp){
              this.getPathLesson();
            }
          },
          error: error => console.error('Error trayendo el booleano', error)
        }
      )
  }

  ngOnInit() {
    this.user = this.localStorage.getCurrentUserAsJson();
    this.coursesService.courses$.pipe(takeUntil(this.destroy$)).subscribe({
      next: courses => {
        if(courses.length > 0){
          this.hasCourses = true;
        }else{
          this.hasCourses = false;
        }
      }
    });
    this.infoUser = this.localStorage.getCurrentUserProfileAsJson();
    this.getInsigniasOfCourses();
    this.filterActivities('Todos los pendientes');
    // this.getPathLesson();
  }

  getActivityWithLessonPath(activity: DataLesson) {
    const lessonId = activity.relationships.field_lesson?.data?.id;
    if (!lessonId) {
      console.warn('Lesson ID is undefined');
      return of(null);
    }
    return this.lessonsService.getLessonById(lessonId).pipe(
      map(lesson => {
        activity.lessonPath = lesson.attributes.path.alias;
        return activity;
      }),
      catchError(error => {
        console.error('Error in getLessonById:', error);
        return of(null);
      })
    );
  }

  getPathLesson() {
    this.content.filteredActivities$
      .pipe(
        takeUntil(this.destroy$),
        switchMap(courses =>
          forkJoin(
            courses.map(course => {
              if (course.activities.length === 0) {
                return of({ ...course, activities: [] });
              }
              return forkJoin(
                course.activities.map((activity: any) => {
                  return this.getActivityWithLessonPath(activity).pipe(
                    catchError(error => {
                      console.error('Error in getActivityWithLessonPath:', error);
                      return of(null);
                    })
                  );
                })
              ).pipe(
                map(activities => ({ ...course, activities }))
              );
            })
          )
        ),
      )
      .subscribe({
        next: () => {
          this.content.isLinkArrived = true;
          this.filterActivities('Todos los pendientes');
        },
        error: error => {
          console.error('Error trayendo las actividades', error);
        }
      });
  }

  onClick(opt:string){
    this.option = opt;
    this.filterActivities(opt);
  }

  filterActivities(option: string){
    this.content.filteredActivities$.pipe(takeUntil(this.destroy$)).subscribe({
        next: courses => {
          this.activities = courses.flatMap(course =>
            course.activities.map((activity:any) => ({...activity, courseTitle: course.title, coursePath: course.path }))
          );
            switch (option) {
                case 'Esta semana':
                    this.filteredActivities = this.activities.filter(activity => thisWeek(activity));
                    break;
                case 'Próxima semana':
                    this.filteredActivities = this.activities.filter(activity => nextWeek(activity));
                    break;
                default:
                    this.filteredActivities = [...this.activities];
                    break;
            }
        },
        error: error => {
          console.error('Error trayendo las actividades filtradas', error);
        }
    });
  }

  // getInsigniasOfCourses(){
  //   this.coursesService.courses$.pipe(takeUntil(this.destroy$)).subscribe(courses => {
  //     if(this.certificatesService.certificates.length === 0){
  //       setTimeout(() => {
  //         this.associateCertificatesToCourses(courses);
  //         this.coursesWithInsignia = courses;
  //       }, 1500);
  //     }else{
  //       this.associateCertificatesToCourses(courses);
  //       this.coursesWithInsignia = courses;
  //     }
  //   })
  // }

  getInsigniasOfCourses() {
    combineLatest([
      this.coursesService.courses$,
      this.certificatesService.certificates$
    ])
    .pipe(
      takeUntil(this.destroy$),
      map(([courses, certificates]) => {
        if (certificates.length === 0) {
          this.associateCertificatesToCourses(courses);
        } else {
          this.associateCertificatesToCourses(courses);
        }
        return courses;
      })
    )
    .subscribe(courses => {
      console.log(courses, 'insignias');
      this.coursesWithInsignia = courses;
    });
  }


  private associateCertificatesToCourses(courses: DataCourse[]){
    courses.forEach(course => {
      const certificate = this.certificatesService.certificates.find((certificate:any) => certificate.courseId === course.attributes.drupal_internal__nid);
      if (certificate) {
        course.certificate = certificate;
      }
      this.insigniasService.getInsigniasOfStudent(course.attributes.drupal_internal__nid, this.user.uid)
      .pipe(
        takeUntil(this.destroy$),
        switchMap(insignias => {
          const insigniaObservables = insignias.map((insignia: any) =>
            this.insigniasService.searchInsignia(insignia.field_insignia[0].target_uuid)
            .pipe(
              switchMap(dataInsignia => {
                const fileId = dataInsignia.relationships.field_image.data?.id;
                const name = dataInsignia.attributes.name;
                return this.content.getFileContent(fileId).pipe(
                  map(fileContent => {
                    insignia.image = fileContent.url;
                    insignia.name = name;
                    return insignia;
                  })
                );
              })
            )
          );

          return forkJoin(insigniaObservables);
        })
      )
      .subscribe(
        {
          next: updatedInsignias => {
            this.insigniasService.insignias = updatedInsignias;
          },
          error: error => {
            console.error('Error trayendo las insignias del estudiante', error)
          }
        }
      );
    });
    return courses;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  // getLoginStatus(){}
}
